/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} St_Val1_TitleInputs */

const en_st_val1_title = /** @type {(inputs: St_Val1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilingual proposal PDF from a verified PRD`)
};

const id_st_val1_title = /** @type {(inputs: St_Val1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proposal PDF dwibahasa dari PRD terverifikasi`)
};

/**
* | output |
* | --- |
* | "Bilingual proposal PDF from a verified PRD" |
*
* @param {St_Val1_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const st_val1_title = /** @type {((inputs?: St_Val1_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<St_Val1_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_st_val1_title(inputs)
	return en_st_val1_title(inputs)
});